export const iconFontAwesomePoliticalLandmarkDome = (
	<i className="fa-solid fa-landmark-dome"></i>
);
